import request from '@/utils/request'

export function fetchList (params) {
  return request({
    url: '/label/list',
    method: 'get',
    params: params
  })
}

export function createTagGroup (data) {
  return request({
    url: '/label/create',
    method: 'post',
    data: data
  })
}

export function getTagGroup (id) {
  return request({
    url: '/label/updateInfo/' + id,
    method: 'get',
  })
}

export function updateTagGroup (id, data) {
  return request({
    url: '/label/update/' + id,
    method: 'post',
    data: data
  })
}

export function deleteTagGroup (ids, status) {
  return request({
    url: '/label/update/deleteStatus?ids=' + ids + '&deleteStatus=' + status,
    method: 'post',
  })
}

export function fetchSupplierTagGroupList (data) {
  return request({
    url: '/label/getMchtLabelList',
    method: 'get',
    params: data
  })
}



// WEBPACK FOOTER //
// ./src/api/tagGroup.js